import { render, staticRenderFns } from "./BandejaLinkPacienteCobroComponente.vue?vue&type=template&id=5f520904"
import script from "./BandejaLinkPacienteCobroComponente.vue?vue&type=script&lang=js"
export * from "./BandejaLinkPacienteCobroComponente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports